// Hero: split dossier layout. Text column (back link, mono kicker, title,
// tags, action links) sits beside the cover image, which is presented as a
// framed "plate" with corner brackets — contained, not a full-bleed banner.
// Clicking the plate opens it in the lightbox.
import React from 'react';
import { Link } from 'react-router-dom';

function formatDate(value) {
  if (!value) return null;
  try {
    return new Date(value).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
    });
  } catch {
    return null;
  }
}

export default function ProjectHero({ project, onOpenImage }) {
  const date = formatDate(project.projectDate);
  const tags = Array.isArray(project.tags) ? project.tags : [];

  return (
    <header className="pd-hero">
      <div className="pd-hero__text">
        <Link to="/projects" className="pd-hero__back">
          ← All projects
        </Link>
        <p className="pd-hero__kicker">
          Project{date && <span className="pd-hero__date"> — {date}</span>}
        </p>
        <h1 className="pd-hero__title">{project.title}</h1>

        {tags.length > 0 && (
          <ul className="pd-hero__tags">
            {tags.map((tag) => (
              <li key={tag} className="pd-tag">
                {tag}
              </li>
            ))}
          </ul>
        )}

        {(project.websiteUrl || project.sourceUrl) && (
          <div className="pd-hero__actions">
            {project.websiteUrl && (
              <a
                href={project.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="pd-hero__action pd-hero__action--primary"
              >
                Visit site ↗
              </a>
            )}
            {project.sourceUrl && (
              <a
                href={project.sourceUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="pd-hero__action"
              >
                Source ↗
              </a>
            )}
          </div>
        )}
      </div>

      <div className="pd-hero__plate">
        <button
          type="button"
          className="pd-hero__frame"
          onClick={() => onOpenImage({ src: project.imageUrl, caption: null })}
          aria-label={`Open cover image for ${project.title}`}
        >
          <img
            src={project.imageUrl}
            alt={project.title}
            className="pd-hero__img"
            // Above the fold — load eagerly.
            loading="eager"
            decoding="async"
          />
        </button>
        <span className="pd-hero__plate-label" aria-hidden="true">
          Cover
        </span>
      </div>
    </header>
  );
}
